import React, { forwardRef } from 'react';
import { InputComponentProps } from './validated-input';
import { useRefAssigner } from '../../../hooks/use-ref-assigner';

import './input-with-hidden-label.scss';

export interface InputWithHiddenLabelProps {
    inputId: string;
    labelText: string; // For screenreaders only
    inputProps?: InputComponentProps;
    testId?: string;
}

export const InputWithHiddenLabel = forwardRef(function (
    { inputId, labelText, inputProps, testId = 'input-with-hidden-label' }: InputWithHiddenLabelProps,
    ref: React.RefCallback<HTMLInputElement> | React.MutableRefObject<HTMLInputElement>,
): React.ReactElement {
    const refAssigner = useRefAssigner(ref);

    return (
        <div className="input-with-hidden-label">
            <input
                data-testid={testId}
                id={inputId}
                ref={refAssigner}
                {...inputProps}
                className="input-with-hidden-label__input"
            />
            <label
                data-testid="input-with-hidden-label-label"
                className="input-with-hidden-label__label sr-only"
                htmlFor={inputId}
            >
                {labelText}
            </label>
        </div>
    );
});
